import { render, staticRenderFns } from "./content-editable.vue?vue&type=template&id=47b1392a"
import script from "./content-editable.vue?vue&type=script&lang=js"
export * from "./content-editable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b1392a')) {
      api.createRecord('47b1392a', component.options)
    } else {
      api.reload('47b1392a', component.options)
    }
    module.hot.accept("./content-editable.vue?vue&type=template&id=47b1392a", function () {
      api.rerender('47b1392a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/content-editable.vue"
export default component.exports